import { usePage } from '@inertiajs/react';
import React from 'react';
import DriveSyncLayout from '../../layouts/DriveSyncLayout';
import AnalyticsGrid from './AnalyticsGrid';
import AnalyticsHeader from './AnalyticsHeader';

export default function Index() {
  const { props } = usePage();

  return (
    <DriveSyncLayout>
      <AnalyticsHeader />
      <AnalyticsGrid {...props} />
    </DriveSyncLayout>
  );
} 